import { render } from "./ClassReport.vue?vue&type=template&id=58f0dfd2&scoped=true"
import script from "./ClassReport.vue?vue&type=script&lang=js"
export * from "./ClassReport.vue?vue&type=script&lang=js"

import "./ClassReport.vue?vue&type=style&index=0&id=58f0dfd2&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f0dfd2"]])

export default __exports__